<template>
  <div v-if="!hideMe" >
    <div class="flex flex-align-center">
      <SearchInput
        ref="searchTagInput"
        v-model="searchQuery"
        class="greedy"
        placeholder="Search..."
        full-width
        flat
        no-hover
        :icon-size="12" />
      <!-- <div
        v-if="!schema.readOnly"
        class="ml-2 btn-highlight show-hand flex flex-align-center"
        @click="removeAll()" >
        <p class="lighter">Delete all</p>
        <SBIcon
          style="margin-right: 6px;"
          :icon="SBIconList.TRASH"
          :color="SBColors.blackUltralight"
          :hover-icon-color="SBColors.blackPrimary"
          :hover-size="24"
          :size="14"
          pointer />
      </div> -->
    </div>

    <DefaultList
      v-if="!remoteDataKey || remoteDataKey === 'default'" />
    <UrlList
      v-else-if="remoteDataKey === 'url'"
      :items="listData.filter(item => !itemsToRemove.includes(item.uid)).filter(item => item.url.includes(searchQuery))"
      :read-only="schema.readOnly"
      :remove-callback="remove" />

    <div
      v-if="searchQuery && !fetchingData && !listData.filter(item => !itemsToRemove.includes(item.uid)).filter(item => item.url.includes(searchQuery)).length"
      class="flex flex-align-center mt-2"
      style="color: #54626c; font-size: 14px; line-height: 1.2;" >
      <span class="emoji-fix no-shrink mr-2">😐</span>
      <p>We could't find anything for <span style="font-weight: 500 !important;">{{ searchQuery }}</span></p>
    </div>

    <!--
    Load more data is shown if there is:
      - no links data which means the first page was not being requested yet so when this comes into view it will trigger
      - next data page present
     -->
    <LoadMoreData
      v-if="!linksData || (linksData && linksData.next)"
      class="mt-3"
      :loading="false"
      @loadMore="fetchData" />
  </div>
</template>

<script>
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SearchInput from '@/components/business/widgets/SearchInput';
import LoadMoreData from '@/components/common/widgets/LoadMoreData';
import api from '@/helpers/api';
import DefaultList from '../../formElements/widgets/DefaultList';
import UrlList from '../../formElements/widgets/UrlList';

export default {
  name: 'RemoteDataForm',
  components: {
    LoadMoreData,
    SBIcon,
    SearchInput,
    DefaultList,
    UrlList,
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    validators: {
      type: String,
      default: '',
    },
    schema: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      SBColors,
      SBIconList,
      listData: [],
      searchQuery: '',
      metaData: null,
      linksData: null,
      fetchingData: false,
      noMoreData: false,
      itemsToRemove: [],
    };
  },
  computed: {
    remoteDataKey() {
      return this.schema.remoteDataKey || 'default';
    },
    hideMe() {
      return !(
        this.searchQuery ||
        this.fetchingData ||
        (
          this.schema &&
          this.schema.endpoint &&
          (
            !this.metaData ||
            (
              this.metaData && this.listData.length
            )
          )
        )
      );
    },
  },
  watch: {
    searchQuery() {
      this.fetchData(true);
    },
    hideMe() {
      if (this.hideMe) {
        this.$parent.setChildData({ hideMe: this.hideMe });
      }
    },
  },
  mounted() {
    if (this.schema.value) {
      this.itemsToRemove = [...this.schema.value.map(item => item.uid)];
    }
  },
  methods: {
    fetchData(searchDataFirstPage = false) {
      if (this.fetchingData) return;

      this.fetchingData = true;
      let endpoint = this.schema.endpoint;
      const params = {
        noPrefix: true,
      };
      if (!searchDataFirstPage && this.linksData && this.linksData.next) {
        endpoint = this.linksData.next;
      } else if (this.noMoreData) {
        this.fetchingData = false;
        return;
      } else {
        params.page = 1;
        params.limit = 255;
        if (this.searchQuery) {
          params[this.schema.searchTag] = this.searchQuery;
        }
      }
      api('GET', endpoint, params, null, 'w')
        .then((response) => {
          this.metaData = response.data.meta;
          this.linksData = response.data.links;
          if (searchDataFirstPage) {
            this.listData = response.data.data;
          } else {
            this.listData = [...this.listData, ...response.data.data];
          }

          if (!this.searchQuery && !response.data.links.next) {
            this.noMoreData = true;
          }
          try {
            this.$parent.setChildData({ count: this.schema.count, total: this.schema.maxLinks, hideMe: this.hideMe });
          } catch (_) {
            // parent is not a JSONForm wrapper and doesn't expect setChildData
          }
        })
        .finally(() => {
          this.fetchingData = false;
        });
    },
    removeAll() {},
    remove(item) {
      const index = this.listData.findIndex(i => this.$lodash.isEqual(i, item));
      this.itemsToRemove.push(this.listData[index].uid);
      this.listData.splice(index, 1);
      this.emitData();
    },
    emitData() {
      this.$emit('input', {
        valid: true,
        name: this.schema.returnKey || '',
        removeCount: this.itemsToRemove.length,
        data: {
          value: this.itemsToRemove.map(item => (
            {
              uid: item,
              action: 'delete',
            }
          )),
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-highlight {
  &:hover {
    p {
      color: $blackPrimary;
    }
    ::v-deep .sb-icon .icon.mask {
      background-color: $blackPrimary !important;
    }
  }
}

.lighter {
  font-size: 14px;
  font-weight: 500;
  color: $blackUltralight;
}

::v-deep {
  .list .list-item {
    height: 34px;
    margin: 0 0 8px;
    padding: 9px 5px 9px 12px;
    border-radius: 10px;
    box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1);
    border: solid 1px $greyBorder;
    background-color: $white;
  }
}
</style>
